
import { MainMenuItem } from "@interia/common/hooks/useMainMenu"



const useMainMenu = (): MainMenuItem[] => {
  return [
    { title: 'O nas', key: 'o-nas', url: `/o-nas`, blank: false, outlined: false, border: '#001273', external: false },
    { title: 'Nasze marki', key: 'nasze-marki', url: '/nasze-marki', blank: false, outlined: false, border: '#054195', external: false },
    {
      title: 'Dla mediów', key: 'dla-mediow', url: '/', blank: false, outlined: false, border: '#00DFB8', external: false, children: [
        { title: 'Aktualności', key: 'aktualnosci', url: '/aktualnosci/1', blank: false, outlined: false, border: '#054195', external: false },
        { title: 'Materiały do pobrania', key: 'materialy-do-pobrania', url: '/materialy-do-pobrania', blank: false, outlined: false, border: '#054195', external: false },
      ]
    },
    { title: 'Interia extra', key: 'interia-extra', url: 'https://extra.interia.pl/', blank: true, outlined: false, border: '#90D0F2', external: true },
    { title: 'Kontakt', key: 'kontakt', url: '/kontakt', blank: false, outlined: false, border: '#053A81', external: false },
    { title: 'Kariera', key: 'kariera', url: process.env.GATSBY_CAREER_URL ?? '', blank: false, outlined: true, external: true, background: '#F60B46', border: '#ffffff' }
  ]
}

export default useMainMenu